<template>
  <div class="demo-spin-article">
    <div v-if="!loaded">
      <div class="header-div">
        <Row type="flex" :gutter="24" align="bottom">
          <Col :xs="24" :sm="12" :lg="5" class="mb-10">
            <div class="mb-5">Выберите тип:</div>
            <Select
              v-model="type"
              class="select_button"
              placeholder=""
            >
              <Option
                v-for="item in typeOptions"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}
              </Option>
            </Select>
          </Col>
          <Col :xs="24" :sm="12" :lg="7" class="mb-10">
            <div class="mb-5">Не выгружать, если дублируется по полю:</div>
            <Select
              v-model="duplicateControl"
              class=""
              clearable
              placeholder="Выбрать..."
            >
              <Option
                v-for="item in duplicateControlOptions"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}
              </Option>
            </Select>
          </Col>
          <Col :xs="24" :sm="12" :lg="7" class="mb-10">
            <div class="mb-5">Формировать остатки для торговой точки:</div>
            <Select
              v-model="store"
              class=""
              clearable
              placeholder="Выбрать..."
            >
              <Option
                v-for="item in storeOptions"
                :value="item.id"
                :key="item.id"
              >{{ item.name }}
              </Option>
            </Select>
          </Col>

          <!-- CREATE -->
          <Col :xs="24" :sm="24" :lg="5" class="text-right mb-10">
            <Button
              type="info"
              class=""
              @click="saveAction"
            ><span class="d-flex align-center">
            Импорт
            <img src="/static/svg/import.svg" alt="">
          </span>
            </Button
            >
          </Col>
        </Row>


        <!--<Divider></Divider>-->
        <div class="alert-msg">
          <div class="d-flex align-center">
            <img src="/static/svg/attention.svg" alt="">
            <span>
              Скопируйте товары в вашей таблице, кликните на ячейку и нажмите Ctrl+V - товары
            вставятся. Далее назовите столбцы и нажмите «Импортировать»
            </span>
          </div>
        </div>
      </div>


      <!--      <Table :columns="headers" :data="data"></Table>-->


      <div class="content-div">
        <table style="width: 99%">
          <thead>
          <tr>
            <td></td>
            <!--            v-if="isDisplayHeader(col_idx)"-->
            <td v-for="(col, col_idx) in data[0]"

                :key="col_idx">
              <Select
                :value="headers[col_idx]"
                @on-change="changeHeader($event, col_idx)"
                class="select_head"
                clearable
                placeholder="Не назначено"
              >
                <Option
                  v-for="item in headerOptions"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}
                </Option>
              </Select>
            </td>
          </tr>
          </thead>
          <tbody>

          <tr class="custom-fields" v-for="(row, row_idx) in data" :key="row_idx">
            <td>
              <Button
                @click="deleteRow(row_idx)"
                size="small"
                icon="md-trash"
                style="box-shadow: none; background: transparent; border: none; color: #DEDEDE"
              ></Button>
            </td>
            <td class="td" :tabindex="row_idx + col_idx" v-for="(col, col_idx) in row" :key="col_idx">

              <Select v-if="data[row_idx][col_idx].type === 'group'"
                      v-model="data[row_idx][col_idx].id">
                <Option v-for="item in groups"
                        :value="item.id"
                        :key="item.id">{{item.name}}
                </Option>
              </Select>


              <input v-else
                     type="text"
                     class="td_input"
                     :value="data[row_idx][col_idx]"
                     @keyup="manualEnterData($event, row_idx, col_idx)"
                     @change="inputData($event, row_idx, col_idx)"
                     @paste="pasteData($event, row_idx, col_idx)"/>
            </td>
          </tr>
          </tbody>
        </table>


      </div>
      <Spin size="large" fix v-if="loading"></Spin>
    </div>
    <div v-else>
      <div class="alert-msg d-flex align-center">
        <Icon color="#25D77E" size="64" type="md-checkmark-circle"/>
        <div style="margin-left: 50px">
          <h2>Успешно!</h2>
          <span slot="desc"><h3>Импорт {{typeLabel}} успешно завершен. Для просмотра товаров можете перейти в
          <router-link :to="{name: 'catalog'}">каталог</router-link>.
            <!--<router-link :to="{name: 'catalog_import'}" @click.prevent="forceRerenderMainContent">импорт</router-link>-->
          </h3>
          <br>
          <span class="color-grey fs-15">Импортировано записей: {{ inserted_count }}</span>
          <br>
          <span class="color-grey fs-15">Найдено дубликатов: {{ duplicate_count }}</span>

            <!--<span>{{ inserted_count }}</span>-->
        </span>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
    import {base_url} from "../../http.js";
    import {formatNumber} from "../../base/base_func.js";

    export default {
        name: 'catalogImport',
        components: {
            // reparationForm,
            // reparationUploadFinish
        },
        data() {
            return {
                loading: false,
                loaded: false,
                upload_url: base_url + '/catalog/import/',
                changes_in_url: base_url + '/product_order/changes_in/',
                data: [
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                    ['', '', '', '', '', '', '', '', '', '', '', '', ''],
                ],
                colDataWidth: 0,
                colDataHeight: 0,
                duplicateControlOptions: [
                    {
                        value: 'name',
                        label: 'Наименование'
                    },
                    {
                        value: 'barcode',
                        label: 'Штрих-код GTIN'
                    },
                    {
                        value: 'ntin',
                        label: 'Штрих-код NTIN'
                    },
                    {
                        value: 'sku',
                        label: 'Артикул'
                    }
                ],
                duplicateControl: '',
                headerOptions: [
                    // {
                    //   value: '',
                    //   label: 'Не назначено'
                    // },
                    {
                        value: 'name',
                        label: 'Наименование'
                    },
                    {
                        value: 'group',
                        label: 'Группа'
                    },
                    {
                        value: 'description',
                        label: 'Описание'
                    },
                    {
                        value: 'sku',
                        label: 'Артикул'
                    },
                    {
                        value: 'barcode',
                        label: 'Штрих-код GTIN'
                    },
                    {
                        value: 'ntin',
                        label: 'Штрих-код NTIN'
                    },
                    {
                        value: 'base_price',
                        label: 'Розничная цена'
                    },
                    {
                        value: 'trade_price',
                        label: 'Оптовая цена'
                    },
                    {
                        value: 'purchase',
                        label: 'Цена закупки'
                    },
                    {
                        value: 'discount',
                        label: 'Скидка, %'
                    },

                    // {
                    //   value: 'country',
                    //   label: 'Страна'
                    // },
                    {
                        value: 'vat',
                        label: 'НДС, %'
                    },
                    {
                        value: 'unit',
                        label: 'Единица измерения'
                    },
                    {
                        value: 'min_rest',
                        label: 'Мин. остаток'
                    },
                    // {
                    //   value: 'is_weighed',
                    //   label: 'Весовой товар'
                    // }
                ],
                typeOptions: [
                    {
                        value: 'PRODUCT',
                        label: 'Товар'
                    },
                    {
                        value: 'SERVICE',
                        label: 'Услуга'
                    },
                ],
                stores: [],
                storeOptions: [],
                store: '',
                type: 'PRODUCT',
                requiredFields: {
                    name: "Наименование",
                    // base_price: "Цена продажи"
                },
                headers: [],
                inserted_count: 0,
                duplicate_count: 0,
                saved_positions: [],

                groups: '',
                selectCol: {}
            }
        },
        computed: {
            typeLabel() {
                let type;
                // this.typeOptions.forEach((val, index)=>{
                //   if (val.value===this.type) {
                //     type=val.label;
                //   }
                // });
                if (this.type === 'SERVICE') {
                    return 'услуг';
                } else {
                    return 'товаров';
                }

            },
            dataForSave() {
                let data_for_save = [];

                this.data.forEach((value, i) => {
                    //console.log(value);
                    //console.log(i);
                    let row_obj = {};

                    value.forEach((c_value, c) => {
                        //console.log(c_value);
                        //console.log(c);
                        if(c_value.type === 'group') {
                            c_value = c_value.id
                        }
                        if (this.headers[c]) {
                            if (['base_price', 'purchase', 'min_rest', 'barcode', 'ntin', 'vat', 'discount', 'sku', 'trade_price'].includes(this.headers[c]) && 
                            typeof c_value === 'string') {
                              c_value = c_value.replace(/\s/g, '')
                            }
                            row_obj[this.headers[c]] = c_value;
                        }
                    });

                    if (row_obj.name) {
                        row_obj.store = this.store
                        data_for_save.push(row_obj);
                    }
                });
                //console.log(data_for_save)
                return data_for_save;
            },

            dataChangesIn() {
              let changes_in_data = {
                  applied: true,
                  number: "",
                  order_date: new Date().toISOString(),
                  recipient: {
                    id: this.store,
                    type: "customer"
                  },
                  type: "CHANGES_IN"
                };

                let positions = this.saved_positions.filter(saved_position => saved_position.min_rest !== 0 && saved_position.type !== 'SERVICE').map(saved_position => {
                      let position = {...saved_position, base_price: saved_position.purchase, 
                        total_price: saved_position.purchase * saved_position.min_rest,
                        product: saved_position.id, amount: saved_position.min_rest};

                      delete position.purchase;
                      delete position.min_rest;
                      delete position.id;

                      return position;
                  });

                let total_sum = positions.reduce((sum, position) => sum + position.total_price, 0);
                
                changes_in_data.positions = positions
                changes_in_data.total_sum = total_sum

                return changes_in_data;
            },

            uncheckedRequiredField() {
                let unchecked_fields = [];
                for (const key in this.requiredFields) {
                    // console.log(key);
                    if (this.headers.indexOf(key) === -1) {
                        unchecked_fields.push(this.requiredFields[key])
                    }
                }
                return unchecked_fields;
            },
        },
        methods: {
            // forceRerenderMainContent() {
            //   this.reloadMainContentKey += 1;
            // },
            manualEnterData(event, row_idx, col_idx) {
                this.colDataWidth = this.data[0].length;
            },

            isDisplayHeader(idx) {
                return idx < this.colDataWidth;
            },

            inputData(event, r_idx, c_idx) {
                // console.log(event.target.value);
                // console.log(r_idx);
                // console.log(c_idx);
                this.data[r_idx][c_idx] = event.target.value;
            },
            pasteData(event, r_idx, c_idx) {
                this.colDataWidth = 0;

                let insertedData = event.clipboardData.getData('text/plain');
                // console.log(event);
                // console.log(r_idx);
                // console.log(c_idx);

                let rows = insertedData.split(/[\n\r]/g);
                this.data = [];
                let col_max_idx = 0;
                let row_cur_idx = 0;

                for (let index in rows) {
                    // console.log(rows);
                    let cols_str = rows[index];
                    let cols = cols_str.split(/[\t]/g);
                    if (cols.length > col_max_idx) col_max_idx = cols.length;

                    if (cols.length === col_max_idx) {
                        // this.data.push(cols);
                        this.$set(this.data, row_cur_idx, cols);

                        row_cur_idx++;
                    }
                    // for (let col_index in cols) {
                    //   // console.log(cols[col_index]);
                    //   // this.data[index][col_index] = cols[col_index];
                    //    }
                }

                this.data.forEach(item => {
                    item.push('')
                });

                this.colDataWidth = col_max_idx;
                this.colDataHeight = row_cur_idx;


                // event.stopPropagation()
                event.preventDefault();

            },

            deleteRow(idx) {
                if (this.data.length > 1) {
                    this.data.splice(idx, 1);
                } else {
                    this.data.splice(idx, 1);

                    let empty_array = [];

                    let c = 0;
                    while (c < this.colDataWidth) {
                        empty_array.push('');
                        c++;
                    }

                    this.data.push(empty_array);
                }
            },

            changeHeader(item, idx) {
                // console.log(item);
                // console.log(idx);


                this.headers.forEach((value, i) => {
                    if (idx !== i) {
                        if (value === item) {
                            this.$set(this.headers, i, undefined);
                        }
                    }
                });

                if (item === 'group') {
                    this.selectCol[idx] = 'group';
                    this.data.forEach(item => {
                        item[idx] = {
                            type: 'group',
                            id: '',
                        };
                    })
                }
                else {
                    this.data.forEach(item => {
                        if(item[idx].type === 'group') {
                            item[idx] = ''
                        }
                    })
                }


                this.$set(this.headers, idx, item);
                // this.headers[idx] = item;
            },

            // changeGroup(value, idx, idy) {
            //     alert(this.data[idx][idy]);
            // },


            getGroups() {
                const url = base_url + '/catalog/groups/';

                this.$http
                    .get(url)
                    .then(response => {
                        this.groups = response.data.results;
                    })
            },

            getStores() {
                const url = base_url + '/stores/';

                this.$http
                    .get(url)
                    .then(response => {
                        this.stores = response.data.results;
                        this.storeOptions = this.stores.map(store=> ({id: store.id, name: store.name}))
                        this.store = this.storeOptions[0].id
                    })
                //console.log(this.stores)
            },


            saveAction() {
                const unchecked_fields = this.uncheckedRequiredField;
                // const unchecked_fields = [];
                if (unchecked_fields.length > 0) {
                    // console.log(unchecked_fields);
                    this.$Message.error(
                        `Не выбраны обязательные поля: ${unchecked_fields.join(', ')}`
                    );
                } else {
                    this.saveData();
                }
            },

            saveData() {

                let data_for_save = this.dataForSave;
                if (data_for_save.length > 0) {
                    this.loading = true;
                    this.$http.post(`${this.upload_url}?check_duplicate=${this.duplicateControl}&type=${this.type}`, data_for_save)
                        .then(response => {
                            // this.$router.push({
                            //   name: this.item_type + "_detail",
                            //   params: {id: response.data.id}
                            // });
                            // this.showDetail(response.data.id);
                            // if (this.action === "create") {
                            //   this.$emit("change", response.data.id);
                            // }
                            // this.$emit("reload_table");
                            this.inserted_count = response.data.inserted_count;
                            this.duplicate_count = response.data.duplicate_count;
                            this.saved_positions = response.data.data;

                            if (this.saved_positions.length > 0) {
                                let data_changes_in = this.dataChangesIn;

                                if (data_changes_in.positions.length > 0) {
                                    this.$http.post(`${this.changes_in_url}`, data_changes_in)
                                    .then(response => {
                                        this.$Message.success("Создан документ оприходования позиций");
                                    })
                                    .catch(error => {
                                      this.$Message.error(
                                          "Произошла неизвестная ошибка. Обратитесь в службу технической поддержки."
                                      );
                                    })
                                }
                            }
                            this.$Message.success("Успешно сохранено");
                            this.loaded = true;
                        })
                        .catch(error => {
                            // console.log(error.response);
                            // if (error.response.status === 400) {
                            //   this.showValidationErrorStr(error.response.data);
                            // } else {
                            this.$Message.error(
                                "Произошла неизвестная ошибка. Обратитесь в службу технической поддержки."
                            );
                            // }

                            // this.$Message.error('Произошла непредвиденная ошибка');
                        })
                        .then(() => {
                            this.loading = false;
                        });
                }

            }
        },

        mounted() {
            this.getGroups();
            this.getStores();
            // this.setBreadcrumbs(this.app_breadcrumbs)
            // this.$store.commit('activeMenuItem', 'reparationFileUpload')
        }



        // watch: {
        //   data: {
        //     handler (val, oldVal) {
        //       console.log(1212121212)
        //
        //     },
        //     deep: true
        //   }
        // }
        /*  methods: {
            setBreadcrumbs (values) {
              this.$store.commit('breadcrumbs', values)
            },
            // Загрузка и удаление картинки
            onSuccessImageUpload (response, file, fileList) {
              this.$Message.success('Файл успешно загружен.')
              this.step = 1
              this.data = response.data
            },
            onErrorImageUpload (error, file, fileList) {
              console.log(error)
              // this.$Message.error('response.data.detail');
            },
            onExceededSize (file, fileList) {
              this.$Message.error(`Превышен допустимый размер файла: ${this.maxFileSize} kb`)
            },
            onFormatError (file, fileList) {
              this.$Message.error('Неверный формат файла')
            }
          },
          */
    }
</script>

<style scoped>
  table {
    border-collapse: collapse;
    margin-top: 3px;
  }

  .td {
    text-align: left;
    border: 1px solid rgba(0, 0, 0, 0.1);
    min-width: 160px;
    max-width: 160px;
    min-height: 24px;
    height: 24px;
    padding: 0px;
    cursor: default;
    outline: none;
    outline-offset: -2px;
    position: relative;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
  }

  /*.td:focus {*/
  /*  outline: 2px solid rgb(82, 146, 247);*/
  /*}*/

  /*.td_highlight {*/
  /*outline: 2px solid rgb(82, 146, 247);*/
  /*}*/

  .custom-fields .td_input {
    display: block;
    width: calc(100% - 10px);
    margin: 0 5px;
    box-sizing: border-box;
    font-size: 14px;
    padding: 16px;
    height: 24px;
    color: #212121;
    background-color: #ffffff;
    border: none;
    outline: none;
    border-radius: 25px;

  }


  .td_input::-webkit-input-placeholder {
    color: #e0e0e0;
  }

  .td_input:focus {
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }

  .td_input[type=checkbox], .td_input[type=radio] {
    display: inline-block;
    border: 0;
    border-radius: 0;
    width: auto;
    height: auto;
    margin: 0 0.2rem 0 0;
  }

  .td_input[type=file] {
    border-width: 0;
    padding: 0;
    height: auto;
  }

  .select_head {
    width: 90%;
    margin: 0 auto 10px auto;
  }

  .delete_row_btn {
    margin-right: 10px;
    visibility: hidden;
  }

  tr:hover button {
    visibility: visible;
  }

  .header-div {
    margin-left: 37px;
  }



  .content-div {
    /*background-size: 700px;*/
    /*box-sizing: border-box;*/

    /*display: flex;*/
    /*flex-direction: column;*/
    /*flex-wrap: nowrap;*/


    height: calc(100vh - 325px);
    overflow: auto;
  }

  .alert-msg {
    margin: 32px 0;
    width: 50%;
    min-width: 700px;
    border: none;
    background-color: #F1F1F1;
    font-size: 14px;
    color: rgba(14, 37, 74, 0.6);
    padding: 12px 20px;
    line-height: 1.5;
  }

  .alert-msg img {
    margin-right: 24px;
  }


  .select_button {
    max-width: 200px;
  }

  @media screen and (max-width: 1900px) {
    .td {
      min-width: 150px;
      max-width: 150px;
    }
  }

  @media screen and (max-width: 1500px) {
    .td {
      min-width: 130px;
      max-width: 130px;
    }
  }

  @media screen and (max-width: 1200px) {
    .alert-msg {
      width: 100%;
    }
  }

  @media screen and (max-width: 991px) {

    .alert-msg .d-flex {
      flex-direction: column;
    }

    .alert-msg img {
      display: block;
      margin: 0 auto 12px 0;
      width: 20px;
    }

    .сard-container__type-kit {
      padding: 0;
      box-shadow: none;
    }

    .header-div {
      margin-left: 0;
    }

    .select_button {
      max-width: 100%;
      width: 100%;
    }


  }

</style>


<style>

  .custom-fields .ivu-select {
    margin: 8px 5px;
    width: calc(100% - 10px);
  }
  .custom-fields .ivu-select-selection .ivu-select-placeholder
  {
    padding: 2px 10px;
    color: #666666;
    font-weight: normal;
  }

  .custom-fields .ivu-select-selection .ivu-select-selected-value {
    padding: 2px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/apps/catalog_import/catalogImport.vue